import { useEffect, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { 
  createSearch, 
  fetchSearches, 
  fetchSearch, 
  deleteSearch,
  clearError,
  clearCurrentSearch
} from '../store/slices/searchSlice';
import { CreateSearchParams, SearchListParams, Search } from '../types/search.types';

export const useSearch = () => {
  const dispatch = useAppDispatch();
  const { searches, currentSearch, loading, error, pagination, statistics } = useAppSelector(state => state.search);
  
  const handleCreateSearch = useCallback(async (params: CreateSearchParams): Promise<Search> => {
    const result = await dispatch(createSearch(params));
    if (createSearch.fulfilled.match(result)) {
      return result.payload as Search;
    }
    throw result.payload;
  }, [dispatch]);
  
  const handleFetchSearches = useCallback(async (params?: SearchListParams) => {
    await dispatch(fetchSearches(params));
  }, [dispatch]);
  
  const handleFetchSearch = useCallback(async (id: number) => {
    await dispatch(fetchSearch(id));
  }, [dispatch]);
  
  const handleDeleteSearch = useCallback(async (id: number) => {
    await dispatch(deleteSearch(id));
  }, [dispatch]);
  
  const handleClearError = useCallback(() => {
    dispatch(clearError());
  }, [dispatch]);
  
  const handleClearCurrentSearch = useCallback(() => {
    dispatch(clearCurrentSearch());
  }, [dispatch]);
  
  return {
    searches,
    currentSearch,
    loading,
    error,
    pagination,
    statistics,
    createSearch: handleCreateSearch,
    fetchSearches: handleFetchSearches,
    fetchSearch: handleFetchSearch,
    deleteSearch: handleDeleteSearch,
    clearError: handleClearError,
    clearCurrentSearch: handleClearCurrentSearch,
  };
}; 